import { FunctionComponent as F, useEffect, useRef, useState } from "react";
import { Popper as MuiPopper, Fade, Box } from "@mui/material";

interface IProps
{
  Content: JSX.Element,
  Icon: JSX.Element,
  handleIconClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void | { preventDefault?: boolean };
  handlePopperClickAway?: (event: MouseEvent | TouchEvent) => void | { preventDefault?: boolean },
  state?: [popperOpen: boolean, setPopperOpen: React.Dispatch<React.SetStateAction<boolean>>],
  onClose?: () => void;
}

const IconPopper: F<IProps> = (props: IProps) =>
{
  const iconRef = useRef<HTMLDivElement | null>(null);
  const boxRef = useRef<HTMLDivElement | null>(null);

  const [popperOpen, setPopperOpen] = props.state || useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLDivElement>(iconRef.current);

  const popperRef = useRef<null | HTMLDivElement>(null);

  const handleIconClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) =>
  {
    const preventDefault = props.handleIconClick ? props.handleIconClick(event)?.preventDefault : false;
    if(preventDefault)
      return;

    if(popperOpen)
      props.onClose && props.onClose();

    setPopperOpen(!popperOpen);
    setAnchorEl(event.currentTarget);
  };

  useEffect(() =>
  {
    const handleClickOutside = (event: MouseEvent) =>
    {
      const iconBb = iconRef.current?.getBoundingClientRect();
      // Ignore if icon clicked - handled by its onClick handler
      if(!iconBb || (
        event.clientX >= iconBb?.left && event.clientX <= iconBb?.right &&
        event.clientY >= iconBb?.top && event.clientY <= iconBb?.bottom))
      {
        return;
      }

      if(popperRef.current && !popperRef.current.contains(event.target as Node))
      {
        props.onClose && props.onClose();
        setPopperOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [popperRef]);


  return(
    <>
      <MuiPopper
        sx={{ zIndex: 2 }}
        transition
        id={'Popper'}
        open={Boolean(popperOpen)}
        anchorEl={anchorEl}
        container={anchorEl}
        ref={popperRef}>
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Box ref={boxRef} sx={{
              border: 1,
              p: 2,
              bgcolor: 'background.paper',
              borderRadius: '10px',
              borderColor: 'lightGray' }}>
              {props.Content}
            </Box>
          </Fade>)}
      </MuiPopper>

      <Box onClick={handleIconClick} ref={iconRef}>
        {props.Icon}
      </Box>
    </>);
};

export default IconPopper;
